/*
 * Consent-gated third-party script loader.
 *
 * Reads window.AC_CONSENT_CONFIG (defined by snippets/consent-config.liquid)
 * and injects each entry only when ALL of its required Shopify Customer
 * Privacy consent signals are allowed. All region/consent logic is delegated
 * to Shopify's Customer Privacy API; this file only reads it.
 *
 * Fail-closed: if the API is unavailable, no gated scripts load.
 */
(function () {
  'use strict';

  var loaded = {};

  // Debug logging toggle. Flip to true to log which gated scripts load or are
  // blocked (and why) in the browser console. Set back to false before deploying.
  var DEBUG = false;

  function log() {
    if (DEBUG && window.console) console.info.apply(console, arguments);
  }

  function missingSignals(entry, checks) {
    if (!entry.enabled) return ['(disabled)'];
    if (!Array.isArray(entry.consent)) return ['(no consent array)'];
    return entry.consent.filter(function (sig) {
      var check = checks[sig];
      return !(typeof check === 'function' && check() === true);
    });
  }

  function signalChecks() {
    var cp = window.Shopify.customerPrivacy;
    return {
      analytics: function () { return cp.analyticsProcessingAllowed(); },
      marketing: function () { return cp.marketingAllowed(); },
      preferences: function () { return cp.preferencesProcessingAllowed(); },
      sale_of_data: function () { return cp.saleOfDataAllowed(); }
    };
  }

  function isAllowed(entry, checks) {
    if (!entry.enabled) return false;
    if (!Array.isArray(entry.consent) || entry.consent.length === 0) return false;
    return entry.consent.every(function (sig) {
      var check = checks[sig];
      return typeof check === 'function' && check() === true;
    });
  }

  function injectSrc(entry) {
    var s = document.createElement('script');
    s.src = entry.src;
    var attrs = entry.attrs || {};
    Object.keys(attrs).forEach(function (k) {
      if (attrs[k] === true) {
        s.setAttribute(k, '');
      } else if (attrs[k] !== false && attrs[k] != null) {
        s.setAttribute(k, attrs[k]);
      }
    });
    (document.head || document.body).appendChild(s);
  }

  function inject(entry) {
    try {
      if (entry.type === 'inline' && typeof entry.init === 'function') {
        entry.init();
      } else if (entry.type === 'src' && entry.src) {
        injectSrc(entry);
      }
    } catch (e) {
      if (window.console) console.error('[consent-loader] failed to inject ' + entry.id, e);
    }
  }

  function evaluate() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;
    var config = window.AC_CONSENT_CONFIG || [];
    var checks = signalChecks();
    log('[consent-loader] consent state:', {
      analytics: checks.analytics(),
      marketing: checks.marketing(),
      preferences: checks.preferences(),
      sale_of_data: checks.sale_of_data()
    });
    // An injected script can't be unloaded, so if consent was withdrawn for
    // anything already running, reload: the fresh page won't inject it.
    // Skipped on Shopify's opt-out page, which navigates to its own
    // success URL after opting out (a reload could race that redirect).
    var onOptOutPage = window.location.pathname.indexOf('/pages/data-sharing-opt-out') === 0;
    var revoked = !onOptOutPage && config.some(function (entry) {
      return loaded[entry.id] && !isAllowed(entry, checks);
    });
    if (revoked) {
      log('[consent-loader] consent withdrawn for a loaded script; reloading');
      window.location.reload();
      return;
    }
    config.forEach(function (entry) {
      if (loaded[entry.id]) return;
      if (!isAllowed(entry, checks)) {
        log('[consent-loader] ⛔ blocked "' + entry.id + '" — needs [' +
          (entry.consent || []).join(', ') + '], missing [' +
          missingSignals(entry, checks).join(', ') + ']');
        return;
      }
      inject(entry);
      loaded[entry.id] = true;
      log('[consent-loader] ✅ loaded "' + entry.id + '" (' + (entry.consent || []).join('+') + ')');
    });
  }

  function onReady(error) {
    if (error || !window.Shopify || !window.Shopify.customerPrivacy) {
      if (window.console) console.warn('[consent-loader] Customer Privacy API unavailable; no gated scripts loaded');
      return; // fail-closed
    }
    evaluate();
    document.addEventListener('visitorConsentCollected', evaluate);
  }

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    if (window.console) console.warn('[consent-loader] Shopify.loadFeatures unavailable; no gated scripts loaded');
    return; // fail-closed
  }

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    onReady
  );
})();
